/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

/**
 * Extract filename from Content-Disposition header
 * @param {string} contentDisposition - Content-Disposition header value
 * @returns {string|null} - Extracted filename or null
 *
 * Examples:
 * - "attachment; filename=file.zip" → "file.zip"
 * - "attachment; filename=\"file.zip\"" → "file.zip"
 * - "inline; filename*=UTF-8''file.zip" → "file.zip"
 */
export function extractFilenameFromHeader(contentDisposition) {
  if (!contentDisposition) {
    return null;
  }

  // Try filename*=UTF-8''... format first (RFC 5987)
  const filenameStarMatch = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  if (filenameStarMatch) {
    return decodeURIComponent(filenameStarMatch[1].replace(/['"]/g, ''));
  }

  // Try filename="..." or filename=... format
  const filenameMatch = contentDisposition.match(/filename[^;=\n]*=(['"]?)([^'"\n]*)\1/i);
  if (filenameMatch && filenameMatch[2]) {
    return filenameMatch[2];
  }

  return null;
}

/**
 * Trigger browser download for a blob
 * @param {Blob|ArrayBuffer} data - File data
 * @param {string} filename - Filename to use for download
 */
export function downloadFileInBrowser(data, filename) {
  const blob = data instanceof Blob ? data : new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Cleanup
  setTimeout(() => window.URL.revokeObjectURL(url), 100);
}
